/** SSR-safe check for Android browsers. Useful to gate behavior that
 *  depends on Android-specific limitations (e.g. Chrome for Android's
 *  lack of continuous Web Speech recognition), rather than re-implementing
 *  the user-agent sniff at call sites. */
export function isAndroidBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Android/.test(navigator.userAgent);
}
